module.exports = __webpack_public_path__ + "static/media/Screenshot1.19c70c33.png";